import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { Subscription } from 'rxjs';
import { ElementSlideDownAnimation } from 'src/app/shared/animations/element-slide-down.animation';

@Component({
  selector: 'rich-text-editor',
  templateUrl: 'rich-text-editor.component.html',
  styleUrls: ['rich-text-editor.component.scss'],
  animations: [ElementSlideDownAnimation()],
})
export class RichTextEditorComponent implements OnInit {
  editor = DecoupledEditor;
  capitalizedField: string;
  isFocused = false;
  show = false;

  private formValueChanges: Subscription;

  @Output()
  blur = new EventEmitter<string>();

  @Output()
  textChanged = new EventEmitter<string>();

  @Input()
  field: string;

  @Input()
  fieldName: string = '';

  @Input()
  form: any;

  @Input()
  label: string;

  @Input()
  placeholder: string = '';

  @Input()
  getFocusWhenStart = false;

  @Input()
  readOnly = false;

  @Input()
  clearData = false;

  config = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        '|',
        'fontColor',
        'fontBackgroundColor',
        '|',
        'alignment',
        'numberedList',
        'bulletedList',
        'outdent',
        'indent',
        '|',
        'blockQuote',
        'link',
      ],
      shouldNotGroupWhenFull: true,
    },
    placeholder: '',
  };

  private _data: string = '';
  get data(): string {
    return this._data ? this._data : '';
  }
  set data(value: string) {
    if (value && typeof value === 'string')
      this._data = value.replace(/(^[ \t]*\n)/gm, '<br/><br/>');
  }

  constructor() {}

  ngOnInit(): void {
    this.config.placeholder = this.placeholder;
    this.data = this.form.get(this.field).value;
    this.show = true; //to render text editor after placeholder gets value
    this.capitalizedField = this.capitalize(this.fieldName ? this.fieldName : this.field);

    this.formValueChanges = this.form.valueChanges.subscribe(() => {
      const newValue = this.form.get(this.field).value;
      if (this.data != newValue) {
        this.data = newValue;
      }
    });
  }

  onReady(editor: DecoupledEditor) {
    if (this.readOnly) {
      editor.enableReadOnlyMode('');
    }

    editor.ui
      .getEditableElement()
      .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());

    if (this.getFocusWhenStart) {
      editor.focus();
    }
    editor.ui.focusTracker.on('change:isFocused', (evt, name, value) => {
      this.focusChanged(value);
    });
  }
  onChange(event) {
    const data = event.editor.getData();
    if (this.form) {
      this.form.get(this.field).setValue(data);
      this.form.get(this.field).markAsDirty();
      this.textChanged.emit(data);
    }
  }

  hasErrors() {
    return this.form.get(this.field).touched && this.form.get(this.field).errors;
  }

  capitalize(str) {
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  focusChanged(isFocused: boolean) {
    this.isFocused = isFocused;
    if (!this.isFocused && this.form) {
      this.form.get(this.field).touched = true;
    }
  }

  ngOnDestroy(): void {
    if (this.formValueChanges) this.formValueChanges.unsubscribe();
  }
}
